import React, { useEffect, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import "./style.scss";
import useDateTime from "~/hooks/useDateTime";
import Categories from "~/components/Processes/conversations/utils/categories.json";
import { formatFileSize } from "~/utils/fileUtils";
import CustomeButton from "../Button";
import EditDocumentDescriptionModal from "./EditDocumentDescriptionModal";
import useDocumentDescription from "./useDocumentDescription";
import AttachmentSuccess from "../toast-notification/AttachmentSuccess";
import { useSelector } from "react-redux";

const DocumentDescription = ({
  data,
  id,
  type,
  visible,
  onVisibleChange,
  hideTrigger = false,
  onDescriptionUpdated,
}) => {
  const { formatDateTime } = useDateTime();
  const {
    shoeDialog,
    setShowDialog,
    open,
    setOpen,
    description,
    setDescription,
    handleUpdateDescription,
    isUpdated,
    loading,
    restoreMessage,
    setRstoreMessage,
    resetDescription,
    setResetDescription,
    safeDecode,
  } = useDocumentDescription({ data, id, type, onDescriptionUpdated });
  const { id: userId, role } = useSelector((state) => state.login);

  const truncateText = (text, maxLength = 30) => {
    if (!text) return "-";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };
  const customHeader = (
    <div className="sidebar-header flex align-items-center gap-1">
      <span className="pi pi-info-circle text-xl header-icon" />
      <h3 className="m-0">
        "
        {truncateText(
          data?.name
            ? safeDecode(data?.name)
            : safeDecode(data?.original_file_name),
        )}
        " File Details
      </h3>
    </div>
  );

  const formatDate = (dateStr) => {
    return formatDateTime({
      date: dateStr,
      dateformat: "MMMM do, yyyy, h:mm a",
    });
  };

  const category = Categories?.find((c) => c.code === data?.category)?.name;
  const subCategory = Categories.find(
    (c) => c.code === data?.category,
  )?.subCategory?.find?.((s) => s.code === data?.subCategory)?.name;

  const isControlled = visible !== undefined && onVisibleChange != null;
  const sidebarVisible = isControlled ? visible : open;
  const setSidebarVisible = isControlled
    ? (v) => onVisibleChange?.(v)
    : setOpen;

  if (isControlled && !data) return null;

  return (
    <>
      {!hideTrigger && (
        <i
          className="pi pi-info-circle cursor-pointer action-icon"
          onClick={() =>
            isControlled ? onVisibleChange?.(true) : setOpen(true)
          }
        />
      )}
      <Sidebar
        position="right"
        className="description__sidebar"
        header={customHeader}
        visible={sidebarVisible}
        onHide={() => setSidebarVisible(false)}
      >
        <div className="description__container">
          <div>
            <p className="label">File Original Name</p>
            <p className="detail">
              {data?.original_file_name
                ? safeDecode(data?.original_file_name)
                : "-"}
            </p>
          </div>

          <div>
            <p className="label">Renamed To</p>
            <p className="detail">
              {data?.isPayslipData ? data?.name : data?.name || "-"}
            </p>
          </div>

          <div>
            <p className="label">File Uploaded By</p>
            <p className="detail">
              {data?.createdByData
                ? `${data.createdByData.first_name} ${data.createdByData.last_name} (${data.createdByData.email})`
                : "-"}
            </p>
          </div>

          <div>
            <p className="label">Upload Date</p>
            <p className="detail">
              {data?.createdAt ? formatDate(data?.createdAt) : "-"}
            </p>
          </div>

          <div>
            <p className="label">File Category</p>
            <p className="detail">{category || "-"}</p>
          </div>

          <div>
            <p className="label">File Sub-Category</p>
            <p className="detail">{subCategory || "-"}</p>
          </div>

          <div>
            <p className="label">File Size</p>
            <p className="detail">
              {} {data?.size ? formatFileSize(data?.size) : "-"}
            </p>
          </div>

          <div>
            <p className="label">Description</p>
            <p className="detail">
              {isUpdated
                ? safeDecode(description) || "None"
                : safeDecode(data?.description || "") || "None"}
            </p>
          </div>
        </div>
        {(role === "GXM_ADMIN" ||
          userId === data?.createdByData?.id ||
          userId === data?.created_by) && (
          <CustomeButton
            label={
              data?.description
                ? "Edit description"
                : isUpdated
                  ? "Edit description"
                  : "Add description"
            }
            variant="contained"
            icon="pi pi-pencil"
            iconPos="right"
            onClick={() => {
              setShowDialog(true);
              if (!hideTrigger) setSidebarVisible(false);
            }}
          />
        )}
      </Sidebar>
      <EditDocumentDescriptionModal
        shoeDialog={shoeDialog}
        data={data}
        setShowDialog={setShowDialog}
        description={description}
        setDescription={setDescription}
        handleUpdateDescription={handleUpdateDescription}
        loading={loading}
        setResetDescription={setResetDescription}
        resetDescription={resetDescription}
        safeDecode={safeDecode}
        isUpdated={isUpdated}
      />
      <AttachmentSuccess
        successMsg={restoreMessage}
        setMessages={setRstoreMessage}
      />
    </>
  );
};

export default DocumentDescription;
